import { createFileRoute } from '@tanstack/react-router';
import { AdminUsersScreen } from '@/features/admin/AdminUsersScreen';

export const Route = createFileRoute('/_app/admin/users/')({
  component: AdminUsersScreen,
});
